var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreelance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#ECF4FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0412 16.0838H27V15.4587C27 14.6537 26.3462 14 25.5412 14H23.4575C22.6537 14 22 14.6537 22 15.4587V16.0838H20.9587C20.5487 16.0838 20.18 16.255 19.915 16.5275L24.5 18.92L29.0862 16.5275C28.8212 16.255 28.4512 16.0838 28.0412 16.0838ZM23.25 16.0838V15.4587C23.25 15.3437 23.3437 15.25 23.4587 15.25H25.5425C25.6562 15.25 25.75 15.3437 25.75 15.4587V16.0838H23.25Z",
    fill: "#7EB6F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7888 20.1782C24.6075 20.2732 24.3913 20.2732 24.2113 20.1782L19.5 17.7207V21.2907C19.5 22.0957 20.1537 22.7495 20.9587 22.7495H28.0425C28.8462 22.7495 29.5 22.0957 29.5 21.2907V17.7207L24.7888 20.1782Z",
    fill: "#7EB6F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0413 17.334H31.1663V19.0002H32.8325V28.1665H16.1663V19.0002H17.8325V17.334H15.9575C15.1588 17.334 14.5 17.9915 14.5 18.7915V30.0415C14.5 30.8415 15.1587 31.5002 15.9587 31.5002H22.34C22.2425 31.9177 21.9825 32.5952 21.2887 33.289C21.0275 33.5502 21.2125 34.0002 21.5837 34.0002H27.4175C27.7887 34.0002 27.9737 33.5515 27.7125 33.289C27.02 32.5965 26.7537 31.919 26.65 31.5002H33.0425C33.8412 31.5002 34.5 30.8415 34.5 30.0415V18.7915C34.5 17.9915 33.8412 17.334 33.0413 17.334Z",
    fill: "#2463AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreelance);
export default __webpack_public_path__ + "static/media/Freelance.3546f60b316b67efee94a6981b81c4a2.svg";
export { ForwardRef as ReactComponent };